<template>
  <v-dialog
    v-model="dialog.show"
    :width="dialog.width"
    persistent
    @keydown.esc="cancel"
    :retain-focus="false"
    :overlay-opacity="dialog.hide ? 1 : 0.6"
    :overlay-color="dialog.hide ? '#fefefe' : 'rgb(33, 33, 33)'"
  >
    <v-card style="overflow: hidden">
      <v-card-title class="bg-main fs-14 px-4 py-0 text-white">
        <component v-if="dialog.titleIcon" :is="dialog.titleIcon"></component>
        {{ dialog.title }}
        <v-btn icon dark class="ml-auto" @click="cancel">
          <CrossIcon></CrossIcon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4">
        <span
          class="text-main-14 text-left"
          v-if="dialog.contentHTML"
          v-html="dialog.contentHTML"
        ></span>
        <span class="text-main-14 text-left">{{ dialog.content }}</span>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-center py-2">
        <v-btn
          class="py-0 px-2 br-4 border-1 border-main text-main fs-14 bg-white elevation-0"
          v-if="dialog.onCancel || dialog.hideOnCancel"
          color="danger"
          small
          @click="cancel"
          :loading="dialog.cancelLoading"
        >
          <v-icon v-if="dialog.cancelIcon">{{ dialog.cancelIcon }}</v-icon>
          {{ dialog.cancelText }}
        </v-btn>
        <v-btn
          class="py-0 px-2 br-4 border-1 border-main-blue text-white bg-main-blue ml-3 fs-14 elevation-0"
          v-if="dialog.onSubmit"
          :loading="dialog.loading"
          small
          @click="submit"
        >
          <DeleteIcon v-if="dialog.submitText.toLowerCase().includes('delete')"></DeleteIcon>
          {{ dialog.submitText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import CrossIcon from "@/assets/svg/crossIcon.svg";
import DeleteIcon from "@/assets/svg/carddelete.svg";

export default {
  name: "CommonDialog",
  data: () => ({
    styleSheet: null,
  }),
  computed: {
    ...mapState({
      dialog: (state) => state.dialog,
    }),
  },
  mounted() {
    if (process.env.NODE_ENV !== "development") {
      this.styleSheet = document.createElement("style");
      document.head.appendChild(this.styleSheet);
    }
  },
  watch: {
    dialog(value) {
      if (process.env.NODE_ENV !== "development") {
        if (value.show) {
          this.styleSheet.sheet.insertRule(
            ".v-overlay { top: 0!important; bottom: 0!important;}",
            0
          );
        } else {
          this.styleSheet.sheet.insertRule(
            ".v-overlay { top: 45px !important; bottom: 25px !important;}",
            0
          );
        }
      }
    },
  },
  components: {
    CrossIcon,
    DeleteIcon,
  },
  methods: {
    /**
     * Invoke the onSubmit function
     */
    submit() {
      if (typeof this.dialog.onSubmit === "function") {
        this.dialog.onSubmit();
      }
    },
    /**
     * Invoke the onCancel function if passed
     */
    cancel() {
      if (this.dialog.hideOnCancel) {
        this.$store.dispatch("commonDialog", {
          loading: false,
          cancelLoading: false,
          show: false,
        });
      }
      if (typeof this.dialog.onCancel === "function") {
        this.dialog.onCancel();
      }
    },
  },
};
</script>

<style scoped></style>
